import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Cell } from "react-md";
import {
  ClockInOutCard,
  SummaryCard,
  QualityAssurancePerformanceCard,
  QualityAssuranceAuditResults,
} from "components/Shared/TimeLogs";
import CaseProfile from "containers/Homeowner/CaseProfile/CaseProfile";
import { getTimeLogByDaySummary } from "actions/qualityAssurance";
import { CaseTimeLogWorkTypeEnum } from "interfaces/Mueller.Business.Models.ts";
import {
  getCaseTimeLogByUserPayPeriod,
  updateCaseTimeLog,
  deleteCaseTimeLog,
  addCaseTimeLog,
} from "actions/casetimelog";
import {
  getTimeClockByPayPeriod,
  addTimeClock,
  deleteTimeClock,
  updateTimeClock,
} from "actions/account";
import QAMacCard from "../User/Mac/QAMacCard";
import { getPayPeriodStartDate, getPayPeriodEndDate } from "components/EmployeeTimeLogs";
import { MCard, MSpinner } from "components/Shared";
import { BUSOPS_AGENT_MAC_BONUS_SHOW, QA_CASE_AUDIT_VIEW, EMPLOYEENOTES_VIEW, BUSOPS_TIMELOGS_VIEW, MANAGEMENT_CALENDAR_EDIT } from 'typeConstants/rights';
import { isRightEnabled } from "requests/internetUsers";
import { userHasRight } from "selectors/rights";
import EmployeeTEAM from "components/Employee/EmployeeTEAM";
import QAPerformanceLog from "components/QualityAssurance/QAPerformanceLog.tsx";
import { dateToStringWithDOW } from "components/Shared/Formatters";
import EmployeeCalendar from "components/Employee/EmployeeCalendar.tsx";

const QualityAssuranceTimeLogDetails = ({
  selectedPayPeriod,
  selectedEmployee,
  isTeamCardCollapsible,
  getTimeLogByDaySummary,
  timeLogByDaySummary,
  isFetchingTimeLogByDaySummary,
  timeLogs,
  isFetchingTimeLogs,
  getCaseTimeLogByUserPayPeriod,
  timeClockByPayPeriod,
  isFetchingTimeClockByPayPeriod,
  getTimeClockByPayPeriod,
  addTimeClock,
  isAddingTimeClock,
  isDeletingTimeClock,
  isUpdatingTimeClock,
  deleteTimeClock,
  updateTimeClock,
  hasViewAuditRight,
  canViewNotes,
  canViewPerformance,
  hideAddTEAMNotes,
  canEditCalendarAsManager,
}) => {
  const mounted = useRef(true);
  const [filterDate, setFilterDate] = useState();
  const [refreshSummaryCard, setRefreshSummaryCard] = useState(false);
  const [selectedControlNumber, setSelectedControlNumber] = useState(0);
  const [valuationQATimeLogs, setValuationQATimeLogs] = useState();
  const [fetchingSelectedHasMacRight, setFetchingSelectedHasMacRight] = useState(false);
  const [selectedHasMacRight, setSelectedHasMacRight] = useState(false);

  useEffect(() => {
    if (refreshSummaryCard) setRefreshSummaryCard(false);
  }, [refreshSummaryCard]);

  useEffect(() => {
    setValuationQATimeLogs(timeLogs.filter(tl => CaseTimeLogWorkTypeEnum.VALUATION_REVIEW === tl.workTypeId));
  }, [timeLogs]);

  useEffect(() => {
    setSelectedHasMacRight(false);
    if(selectedEmployee !== null) {
      setFetchingSelectedHasMacRight(true);
      isRightEnabled(selectedEmployee.internetUserId, BUSOPS_AGENT_MAC_BONUS_SHOW, enabled => {
        setFetchingSelectedHasMacRight(false);
        setSelectedHasMacRight(enabled);
      }, mounted);
    }
  }, [selectedEmployee]);

  useEffect(() => {
    return () => mounted.current = false;
  }, []);

  const onfilterDateChange = date => setFilterDate(date && new Date(date));
  const onRefreshSummary = () => setRefreshSummaryCard(true);
  const onControlNumberSelected = controlNumber => {
    if (controlNumber !== selectedControlNumber) setSelectedControlNumber(controlNumber);
  };

  const payPeriodStartDate = getPayPeriodStartDate(selectedPayPeriod.fromDate);
  const payPeriodEndDate = getPayPeriodEndDate(selectedPayPeriod.toDate);
  const showCaseProfile = selectedControlNumber > 0;

  return (
    <>
      {filterDate && <Cell size={12} className="card-style">
        <MCard title={`Cards are currently filtered to ${dateToStringWithDOW(filterDate)}`} actions={[{ icon: "close", helpText: "Clear Filter", onClick: () => setFilterDate(null) }]} />
      </Cell>}
      <Cell size={12} className="employee-timelogs-grid-section-2" style={{ marginTop: 0, paddingTop: 0 }}>  
        <SummaryCard
          summary={timeLogByDaySummary}
          filterDateCallBack={onfilterDateChange}
          isFetchingData={isFetchingTimeLogByDaySummary}
          getData={getTimeLogByDaySummary}
          payPeriodId={selectedPayPeriod.id}
          data={timeLogByDaySummary}
          internetUserId={selectedEmployee.internetUserId}
          employeeName={selectedEmployee.name.firstLast}
          refreshCard={refreshSummaryCard}
          isEmployeeTimeLogsView
          isBusOpsEmployeeTimeLogs
        />
      </Cell>
      <Cell size={6} className="card-style clock-in-out-card">
        <ClockInOutCard
          displayClockInOutButton={false}
          data={timeClockByPayPeriod}
          isFetchingData={isFetchingTimeClockByPayPeriod}
          payPeriod={selectedPayPeriod}
          getData={getTimeClockByPayPeriod}
          isEditable={true}
          addTimeClock={addTimeClock}
          internetUserId={selectedEmployee.internetUserId}
          isAddingTimeClock={isAddingTimeClock}
          isDeletingTimeClock={isDeletingTimeClock}
          isUpdatingTimeClock={isUpdatingTimeClock}
          deleteTimeClock={deleteTimeClock}
          updateTimeClock={updateTimeClock}
          startDate={payPeriodStartDate}
          endDate={payPeriodEndDate}
          refreshSummaryCard={onRefreshSummary}
          filterDate={filterDate}
        />
      </Cell>
      {canViewNotes &&
          <EmployeeTEAM
            cellWidth={6}
            isCollapsible={isTeamCardCollapsible}
            key={`EmployeeTeam-${selectedEmployee.internetUserId}`}
            internetUserId={selectedEmployee.internetUserId}
            hideAddNotes={hideAddTEAMNotes}
            filterDate={filterDate}
          />
      }
      {canViewPerformance && <QAPerformanceLog payPeriodId={selectedPayPeriod?.id} internetUserId={selectedEmployee?.internetUserId} filterDate={filterDate} />}
      {hasViewAuditRight && <Cell size={12}>
        <QualityAssuranceAuditResults
          internetUserId={selectedEmployee.internetUserId}
          filterDate={filterDate}
          onControlNumberSelected={onControlNumberSelected}
        />
      </Cell>}
      <MCard
        title="Employee Calendar"
        cellWidth={12}
        fields={[
          {
            key: "calendar", 
            control: (
              <EmployeeCalendar 
                employeeId={selectedEmployee.employeeId}
                readOnly={!canEditCalendarAsManager}
                allowManagementEdit={canEditCalendarAsManager}
              />)
          }]}
      />        
      {valuationQATimeLogs?.length > 0 && <Cell size={12}>
        <QualityAssurancePerformanceCard
          data={valuationQATimeLogs}
          isFetchingData={isFetchingTimeLogs}
          filterDate={filterDate}
          getData={getCaseTimeLogByUserPayPeriod}
          internetUserId={selectedEmployee.internetUserId}
          payPeriod={selectedPayPeriod}
          startDate={payPeriodStartDate}
          endDate={payPeriodEndDate}
          refreshSummaryCard={onRefreshSummary}
          onControlNumberSelected={onControlNumberSelected}
          headerText="Appraisal QA Performance"
        />
      </Cell>}
      {fetchingSelectedHasMacRight && <MSpinner />}
      {!fetchingSelectedHasMacRight && selectedHasMacRight &&
          <Cell size={12} className="mac-list-cell">
            <QAMacCard internetUserId={selectedEmployee.internetUserId} />
          </Cell>
      }
      {showCaseProfile &&
        <Cell size={12} tabletSize={12} phoneSize={12} style={{ marginTop: 0, paddingTop: 0 }}>
          <CaseProfile
            controlNumber={selectedControlNumber}
            verticalDisplay={true}
          />
        </Cell>
      }
    </>
  );
};

QualityAssuranceTimeLogDetails.propTypes = {
  selectedPayPeriod: PropTypes.object,
  selectedEmployee: PropTypes.object,
  isTeamCardCollapsible: PropTypes.bool,
  // Dispatch and State props
  isFetchingTimeLogs: PropTypes.bool.isRequired,
  timeLogs: PropTypes.array.isRequired,
  getCaseTimeLogByUserPayPeriod: PropTypes.func.isRequired,
  timeClockByPayPeriod: PropTypes.array.isRequired,
  isFetchingTimeClockByPayPeriod: PropTypes.bool.isRequired,
  getTimeClockByPayPeriod: PropTypes.func.isRequired,
  addTimeClock: PropTypes.func.isRequired,
  isAddingTimeClock: PropTypes.bool,
  isDeletingTimeClock: PropTypes.bool,
  deleteTimeClock: PropTypes.func.isRequired,
  updateTimeClock: PropTypes.func.isRequired,
  isUpdatingTimeClock: PropTypes.bool,
  updateCaseTimeLog: PropTypes.func.isRequired,
  isUpdatingTimeLogs: PropTypes.bool,
  deleteCaseTimeLog: PropTypes.func.isRequired,
  isDeletingTimeLogs: PropTypes.bool,
  addCaseTimeLog: PropTypes.func.isRequired,
  isAddingTimeLogs: PropTypes.bool,
  timeLogByDaySummary: PropTypes.object.isRequired,
  isFetchingTimeLogByDaySummary: PropTypes.bool.isRequired,
  getTimeLogByDaySummary: PropTypes.func.isRequired,
  hasViewAuditRight: PropTypes.bool.isRequired,
  canViewNotes: PropTypes.bool,
  canViewPerformance: PropTypes.bool,
  hideAddTEAMNotes: PropTypes.bool,
  canEditCalendarAsManager: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    isFetchingTimeLogs: state.caseTimeLog.isFetchingTimeLogs,
    timeLogs: state.caseTimeLog.timeLogs,
    timeClockByPayPeriod: state.user.timeClockByPayPeriod,
    isFetchingTimeClockByPayPeriod: state.user.isFetchingTimeClockByPayPeriod,
    isAddingTimeClock: state.user.isAddingTimeClock,
    isDeletingTimeClock: state.user.isDeletingTimeClock,
    isUpdatingTimeClock: state.user.isUpdatingTimeClock,
    isUpdatingTimeLogs: state.caseTimeLog.isUpdatingTimeLogs,
    isDeletingTimeLogs: state.caseTimeLog.isDeletingTimeLogs,
    isAddingTimeLogs: state.caseTimeLog.fetching,
    timeLogByDaySummary: state.qualityAssurance.timeLogByDaySummary,
    isFetchingTimeLogByDaySummary: state.qualityAssurance.isFetchingTimeLogByDaySummary,
    hasViewAuditRight: userHasRight(QA_CASE_AUDIT_VIEW)(state),
    canViewNotes: userHasRight(EMPLOYEENOTES_VIEW)(state),
    canViewPerformance: userHasRight(BUSOPS_TIMELOGS_VIEW)(state),
    canEditCalendarAsManager: userHasRight(MANAGEMENT_CALENDAR_EDIT)(state),
  };
};
const mapDispatchToProps = dispatch => ({
  getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId) {
    dispatch(getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId));
  },
  getTimeClockByPayPeriod(internetUserId, payPeriodId) {
    dispatch(getTimeClockByPayPeriod(internetUserId, payPeriodId));
  },
  addTimeClock(internetUserId, dto) {
    dispatch(addTimeClock(internetUserId, dto));
  },
  deleteTimeClock(id) {
    dispatch(deleteTimeClock(id));
  },
  updateTimeClock(id, clockIn, clockOut) {
    dispatch(updateTimeClock(id, clockIn, clockOut));
  },
  updateCaseTimeLog(updatedCaseTimeLog, updateTimeLogFunc) {
    dispatch(updateCaseTimeLog(updatedCaseTimeLog, updateTimeLogFunc));
  },
  deleteCaseTimeLog(id) {
    dispatch(deleteCaseTimeLog(id));
  },
  addCaseTimeLog(dto) {
    dispatch(addCaseTimeLog(dto));
  },
  getTimeLogByDaySummary(internetUserId, payPeriodId) {
    dispatch(getTimeLogByDaySummary(internetUserId, payPeriodId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(QualityAssuranceTimeLogDetails);
